/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { DialogDefaultV2, InputV2, DefaultSelectV2 } from '../../../components/v2';

const restricaoOptions = [
  { id: 'SIM', nome: 'Sim' },
  { id: 'NAO', nome: 'Não' },
];

const InvalidarDialog = ({ open, onClose, onConfirm }) => {
  const [restricaoArea, setRestricaoArea] = useState('');
  const [motivo, setMotivo] = useState('');
  const [restricaoError, setRestricaoError] = useState(false);
  const [motivoError, setMotivoError] = useState(false);

  useEffect(() => {
    if (open) {
      setRestricaoArea('');
      setMotivo('');
      setRestricaoError(false);
      setMotivoError(false);
    }
  }, [open]);

  const handleConfirm = () => {
    let hasError = false;
    if (!restricaoArea) {
      setRestricaoError(true);
      hasError = true;
    }
    if (!motivo || !motivo.trim()) {
      setMotivoError(true);
      hasError = true;
    }
    if (hasError) return;

    const status = restricaoArea === 'SIM' ? 'RESTRICAO_AREA' : 'INVALIDADO';
    onConfirm({ status, motivoRestricao: motivo });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Invalidar Pedido de Voo"
      confirmMessage="Confirmar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <DefaultSelectV2
            label="Possui restrição de área?"
            isRequired
            error={restricaoError}
            options={restricaoOptions}
            value={restricaoArea}
            onSelect={(event) => {
              setRestricaoArea(event.target.value);
              if (event.target.value) setRestricaoError(false);
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Motivo"
            value={motivo}
            onChange={(e) => {
              setMotivo(e.target.value);
              if (e.target.value && e.target.value.trim()) setMotivoError(false);
            }}
            multiline
            rows={3}
            isRequired
            error={motivoError}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

InvalidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default InvalidarDialog;
